export default {
    title: "Narudžbine",
    search: "Pretraži narudžbine",
    paginatorText: "narudžbine(a)",
    status: {
        processing: "Obrađuje se"
    },
    table: {
        orderNumber: "Broj narudžbine",
        orderDate: "Datum naručivanja",
        quantity: "Količina",
        price: "Cijena narudžbine",
        municipality: "Grad",
        status: "Status",
        refund: 'Refundiraj',
        pending: 'Obrađuje se',
        denied: 'Odbijeno',
        approved: 'Refundirano'
    },
    filters: {
        allMonths: 'Svi mjeseci',
        allMunicipalities: 'Svi gradovi',
        allStatuses: 'Svi statusi',
    },
    orderOverview: {
        title: "Pregled narudžbine",
        button: {
            close: "Zatvori",
            cancel: "Otkaži",
            changeStatus: "Promjeni status",
            sendMessage: "Pošalji poruku kupcu"
        },

        details: {
            title: "Podaci o narudžbini",
            orderNumber: "Broj narudžbine",
            date: "Datum narudžbine",
            productNumber: "Broj proizvoda ",
            quantity: "Ukupna količina",
            price: "Cijena narudžbine",
            delivery: "Dostava",
            supplement: "Doplata",
            total: "Ukupna suma"
        },

        note: "Napomena",

        paymentDetails: {
            title: "Podaci o plaćanju",
            paymentMethod: 'Način plaćanja',
            cashOnDelivery: "Pouzećem",
            creditCard: "Kreditnom karticom",
            successful: 'uspješno',
            unsuccessful: 'neuspjelo',
            status: 'Status',
            code: 'Šifra transakcije',
            date: 'Datum transakcije'
        },

        customerDetails: {
            title: "Podaci o kupcu",
            name: "Ime i prezime",
            city: "Grad",
            address: "Ulica",
            phone: "Broj telefona",
            email: "Email"
        },
    },
    orderStatus: {
        title: "Promjena statusa",
        subtitle: "Odaberite novi status narudžbine.",
        packed: "Pakuje se",
        transit: "U tranzitu",
        button: {
            close: "Zatvori",
            confirm: "Potvrdi",
        },
        info: "Nakon promjene novi status se ne može vratiti u prethodni.",
        cannotBeCanceled: "Nakon promjene u bilo koji od ovih statusa narudžbina se ne može otkazati.",
    },
    orderStatuses: {
        processed: "Obrađuje se",
        packaging: "Pakuje se",
        canceled: "Otkazano",
        in_transit: "U tranzitu",
        delivered: "Dostavljeno",
        confirmed: "Potvrđeno"
    },
    cancelOrder: {
        title: "Otkazivanje narudžbine",
        description: "Da li ste sigurni da želite da otkažete ovu narudžbinu? Ova akcija je trajna i ne može se promijeniti. ",
        button: {
            close: "Zatvori",
            cancel: "Otkaži",
        },
    },
    requestRefundModal: {
        title: "Zahtijevaj povraćaj novca",
        cancel: "Otkaži",
        send: "Pošalji",
        message: "Poruka",
        messagePlaceholder: "Unesite detalje"
    }
}
